<div class="popup-wrapper">
  <span class="lnr lnr-cross default-cross" *ngIf="showCross" (click)="onCloseItem()"></span>
  <ng-content select=".inner"></ng-content>
</div>
